import { IndividualCreateScreen } from '../features/individuals/screens/IndividualCreateScreen';

export const IndividualCreatePage = () => {
  return <IndividualCreateScreen />;
};
